<template>
  <div v-if="retribution" class="relative bg-white rounded-2xl shadow-md p-6 mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2">
      <StackedField label="Prime vendeur" :value="formatPrice(retribution.sellerAmount)" />
      <StackedField v-if="!isSeller" label="Prime manager" :value="formatPrice(retribution.managerAmount)" />
    </div>

    <!-- Total Section -->
    <div v-if="!isSeller" class="mt-6 pt-4 border-t border-gray-100">
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-600">Total</span>
        <span class="text-lg font-semibold text-gray-900">
          {{ formatPrice(totalAmount) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { StackedField, formatPrice } from "@estaly/ui";

import { mapGetters } from "vuex";

export default {
  components: {
    StackedField,
  },
  props: ["retribution"],
  methods: {
    formatPrice,
  },
  computed: {
    ...mapGetters("auth", ["isSeller"]),

    totalAmount() {
      if (!this.retribution) return 0;
      const sellerAmount = Number(this.retribution.sellerAmount) || 0;
      const managerAmount = Number(this.retribution.managerAmount) || 0;
      return sellerAmount + managerAmount;
    },
  },
};
</script>
